import { CachedValue, DatabaseClient } from 'src/database/databaseClient.ts';
import { DATABASE_CACHE_KEY } from 'src/database/constants.ts';
import { debounce } from 'src/database/debounce.ts';

export async function createDatabaseClient(
    dbCache: Map<string, CachedValue>,
    databaseCache: LocalForage,
): Promise<DatabaseClient> {
    return new DatabaseClient(dbCache, debounce((cache: Map<string, CachedValue>) => {
        // eslint-disable-next-line no-console
        databaseCache.setItem(DATABASE_CACHE_KEY, cache).then(() => null).catch((e) => console.error(e));
    }, 200));
}
